export class EventError {
  private callback: string;
  private success: boolean;
  private type: string;

  constructor() {
    this.success = false;
  }

  public setType(isUsaContract: boolean) {
    this.type = isUsaContract ? 'Trading Global' : 'Trading';
  }

  public getType(): string {
    return this.type;
  }

  public setCallback(callback: string) {
    this.callback = callback;
  }

  public getEventError() {
    if (this.type) {
      return {
        Callback: this.callback,
        Success: this.success,
        Type: this.type,
      };
    }

    return {
      Callback: this.callback,
      Success: this.success,
    };
  }
}
